import { ProductCompareStore } from "./products/compareStore.js";
import { ProductListController } from "./products/listController.js";
import { ProductVariantController } from "./products/variantController.js";
import { ProductInquiryController } from "./products/inquiryController.js";

export default class ProductInteractions {
  constructor() {
    const compareBaseUrl =
      document.querySelector(".js-compare-open")?.dataset.compareBase ||
      document.querySelector(".js-compare-go")?.getAttribute("href") ||
      "";

    this.compare = new ProductCompareStore({
      compareBaseUrl,
      toast: this.toast.bind(this),
    });

    this.compare.bindButtons(document);
    this.compare.bindGlobalActions();
    this.compare.render();

    this.list = new ProductListController({
      toast: this.toast.bind(this),
      onAfterRender: () => {
        this.compare.bindButtons(document);
        this.compare.bindGlobalActions();
        this.compare.render();
      },
    });

    this.variant = new ProductVariantController();
    this.inquiry = new ProductInquiryController({ toast: this.toast.bind(this) });
    this.trackView();
  }

  trackView() {
    const root = document.querySelector(".product-detail[data-product-id]");
    if (!root) return;

    const viewUrl = root.dataset.trackViewUrl;
    const durationUrl = root.dataset.trackDurationUrl;
    if (viewUrl) {
      fetch(viewUrl, { method: "POST", headers: { "Content-Type": "application/json" } }).catch(() => {});
    }

    const startedAt = Date.now();
    let sent = false;
    const flush = () => {
      if (sent || !durationUrl) return;
      sent = true;
      const seconds = Math.max(1, Math.round((Date.now() - startedAt) / 1000));
      const body = JSON.stringify({ seconds });
      if (navigator.sendBeacon) {
        const blob = new Blob([body], { type: "application/json" });
        navigator.sendBeacon(durationUrl, blob);
        return;
      }
      fetch(durationUrl, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
    };

    window.addEventListener("pagehide", flush, { once: true });
    window.addEventListener("beforeunload", flush, { once: true });
  }

  toast(message, type = "success") {
    const existing = document.querySelector(".contact-toast");
    if (existing) existing.remove();

    const toast = document.createElement("div");
    toast.className = `contact-toast contact-toast--${type === "info" ? "success" : type}`;
    toast.innerHTML = `<div class="contact-toast__message">${message}</div>`;
    document.body.appendChild(toast);

    setTimeout(() => toast.classList.add("--show"), 10);
    setTimeout(() => {
      toast.classList.remove("--show");
      setTimeout(() => toast.remove(), 250);
    }, 2200);
  }
}
